import _ from 'lodash';

function isReferralClosedByCoordinationCenter(referral) {
  const referralCase = _.get(referral, 'case');
  return ['sent', 'in_review'].includes(_.get(referral, 'state')) && _.get(referralCase, 'outcome') != null;
}

export default isReferralClosedByCoordinationCenter;
